import { Box } from '@material-ui/core';
import { AILoader } from 'pages/products/components';

export const DialogLoader = ({ messages }: { messages: string[] }) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="100%"
    width="100%"
    minHeight={400}
    minWidth={400}>
    <AILoader messages={messages} />
  </Box>
);
